<template lang='pug'>
	r-form( 
		ref='form'
		reset-text='restablecer'
		submit-text='guardar'
		v-bind='formProps'
		v-model='formData'
		@reset='reset'
		@submit='submitChangePassword'
	)
		template(
			slot='header-actions'
			slot-scope='props'
		)
			v-btn(
				class='my--2'
				color='accent'
				:disabled='props.disabled'
				@click='submitSendEmailRestorePass'
			) enviar correo &nbsp;
				v-icon mail
		template( 
			slot='footer-actions' 
			slot-scope='props' 
		)
			v-btn(
				block
				class='ml-3'
				color='accent'
				:disabled='props.disabled'
				@click='submitGeneratePassword'
			) generar contraseña
</template>

<script>
	//
	import { random, times } from 'lodash'
	import { mapActions } from 'vuex'
	//
	import { RForm } from '../../../components/reusable_components/next'
	import GUserModel from '../../../models/General/GUser'
	import Translator from '../../../services/translator'
	//
	import GUserFields from './GUserFields'
	//
	export default {
	    name: 'user-update-password',
	    components: {
	        RForm,
	    },
	    computed: {

	        /**
	         * @description
	         * Computed form props
	         *
	         * @return     {Object}  { description_of_the_return_value }
	         */
	        formProps() {
	            return {
	            	fields: GUserFields().variant('password'),
	            	title: this.formTitle,
	            }
	        },

	        /**
	         * @description
	         * Computed from title
	         *
	         * @return     {<type>}  { description_of_the_return_value }
	         */
	        formTitle() {
	        	return `usuario #${this.$route.params.id}`
	        },

	        /**
	         * @description
	         * Computed view title
	         *
	         * @return     {<type>}  { description_of_the_return_value }
	         */
	        viewTitle() {
	        	return `Contraseña de ${this.formTitle}`
	        },
	    },
	    data () {
	        return {
	        	formData: {},
	        }
	    },
	    methods: {

	        /**
	         * 
	         */
	        error(error){
	            this.$toast.error( Translator( GUserModel, error.response.data ) )
	        },

	    	/**
	    	 * @description
	    	 * Fetches the object.
	    	 *
	    	 * @return     {<type>}  { description_of_the_return_value }
	    	 */
	    	fetch() {
	    		return GUserModel
	    			.modeler()
	    			.find(this.$route.params.id)
	    			.then(this.setFormData)
	    	},
	    	
	    	/**
	    	 * @description
	    	 * Resets the view.
	    	 */
	    	reset() {
	    		return this
	    			.wait(true)
	    			.then(this.fetch)
	    			.then(this.wait)
	    	},

	    	/**
	    	 * @description
	    	 * Sets the form data.
	    	 *
	    	 * @param	{<type>}	GUser model
	    	 */
	    	setFormData(model) {
	    		
	    		//
	    		this.formData = model.reset()
	    		
	    		//
	    		this.formData.password = ''
	    		this.formData.password_repeat = ''
	    	},

	    	/**
	    	 * @description
	    	 * { function_description }
	    	 */
	    	submitChangePassword() {
	    		this.wait(true)
	    			.then(this.toChangePassword)
	    			.then(this.wait)
	    	},

	    	/**
	    	 * @description
	    	 * { function_description }
	    	 */
	    	submitGeneratePassword() {
	    		this.wait(true)
	    			.then(this.toGeneratePassword)
	    			.then(this.wait)
	    	},

	    	/**
	    	 * @description
	    	 * { function_description }
	    	 */
	    	submitSendEmailRestorePass() {
	    		this.$toast.confirm('¿Desea enviar correo para restablecer contraseña?', this.$toaster(this, this.toSendEmailRestorePass))
	    	},

	    	/**
	    	 * @description
	    	 * { function_description }
	    	 */
	    	successGeneratePassword() {
	    		this.$toast.success('Contraseña generada exitosamente.')
	    	},
	    	
	    	/**
	    	 * @description
	    	 * { function_description }
	    	 */
	    	successRestorePassword() {
	    		this.$toast.success('Contraseña actualizada exitosamente.')
	    	},

	    	/**
	    	 * @description
	    	 * { function_description }
	    	 *
	    	 * @param      {<type>}  res     The resource
	    	 */
	    	successSendEmailRestorePass(res) {
	    		this.$toast.success(res.data.message)
	    	},

	    	/**
	    	 * @description
	    	 * Returns a change password representation of the object.
	    	 */
	    	toChangePassword() {
	    		return new GUserModel({ id: 'restore' })
	    			.password()
	    			.sync(this.formData.toRestorePassword())
	    			.then(this.successRestorePassword)
	    			.catch(this.error)
	    	},

	    	/**
	    	 * @description
	    	 * Returns a generate password representation of the object.
	    	 */
	    	toGeneratePassword() {
	    		return this.formData
	    			.genNewPasssword()
	    			//.then(this.successGeneratePassword)
	    			//.catch(this.error)
	    	},

	    	/**
	    	 * @description
	    	 * Returns a send email restore pass representation of the object.
	    	 */
	    	toSendEmailRestorePass() {
	    		this.formData
	    			.sendEmailRestorePass()
	    			.attach()
	    			.then(this.successSendEmailRestorePass)
	    			.catch(this.error)
	    	},

	    	/**
	    	 * @description
	    	 * Set form wait data
	    	 *
	    	 * @param	{boolean}	[value=false]  The value
	    	 * @return	{Promise}	{ description_of_the_return_value }
	    	 */
	    	wait(value = false) {
	    		return this.$refs.form.setWait(value)
	    	}
	    },
	    beforeMount () {
	        this.setTitle(this.viewTitle)
	    },
	    mounted() {
	    	this.reset()
	    },
	}
</script>